import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CurrencyMaskInputMode } from 'ngx-currency';
import { FundingService } from '../../../../../../shared/services/funding.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { KycService } from '../../../../../../shared/services/kyc.service';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

declare const MonnifySDK: any;

@Component({
    selector: 'app-onboarding-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss'],
})
export class PaymentComponent implements OnInit {
  

    @ViewChild('template', { static: false }) templateRef: TemplateRef<any>;

    amount: number;
    reference = '';
    paymentMethods = [
        {
            name: 'Bank Transfer',
            active: true,
            imageUrl: '',
        },
    ];

    currencyOptions = {
        align: 'left',
        allowNegative: false,
        allowZero: false,
        decimal: '.',
        precision: 2,
        prefix: '',
        suffix: '',
        thousands: ',',
        nullable: true,
        min: null,
        max: null,
        inputMode: CurrencyMaskInputMode.NATURAL,
    };
    result: any;
    exchangeRate: any;
    usExchangeRate: any;
    todayDate = new Date();

    userinfo: any;
    title: string;
    val: any;
    amounts: number;
    converted: any;
    MNfref: any;
    hh: any;
    vwallet: any;
    virtualAccount: any;
    walletId: any;
    fee: number;
    total: number;
    newamount: number;
    currency: string;
    errMsg:string;
    error: boolean;
    check: boolean;

    makePayment(form) { }

    toggleAccordion(index) {
        this.val = index;
        this.getPaymentRef();
        this.paymentMethods.map((el) => (el.active = false));
        this.paymentMethods[index].active = !this.paymentMethods[index].active;
    }
    setActiveTemplate(index) {
        switch (index) {
            case 0:
                return 'bank';
            case 1:
                return 'paystack';
            case 2:
                return 'monnify';
            default:
                return 'interswitch';
        }
    }

    constructor(
        private api: FundingService,
        private SpinnerService: NgxSpinnerService,
        private toastr: ToastrService,
        private wallet: KycService,
        private route: Router,
        private ngbmodalService: NgbModal,
        private router: ActivatedRoute
    ) { }

    ngOnInit() {


        const interswitch = document.createElement('script');
        interswitch.async = true;
        interswitch.src =
            'https://qa.interswitchng.com/collections/public/javascripts/inline-checkout.js';
        document.body.appendChild(interswitch);

        const monnify = document.createElement('script');
        monnify.async = true;
        monnify.src = 'https://sandbox.sdk.monnify.com/plugin/monnify.js';
        document.body.appendChild(monnify);

        //fetch wallet

        //fetch all channels
        this.channels();
        //fetch user Info
        this.getUsersInfo();
    }


    channels() {
        this.SpinnerService.show();
        this.api.channels().subscribe((res: any) => {
            if(res.code == 200){
                this.result = res.data;
                this.result.forEach((element) => {
                    this.paymentMethods.push({
                        name: element.name,
                        imageUrl: element.imageUrl,
                        active: false,
                    });
                });
                this.getTodayRate();
            }
           
            // localStorage.removeItem('advAmount');
            this.SpinnerService.hide();
        },err =>{
            this.SpinnerService.hide();
            this.error = true;
            this.errMsg = err.error.message;
        });
    }

    getTodayRate() {
        this.api.rate().subscribe((res: any) => {
            if(res.code == 200){
                this.exchangeRate = res.data.buy;
                this.usExchangeRate = res.data.sell;
            }
            else{
                this.exchangeRate = 0;
                this.usExchangeRate = 0;
            }
           
        },
        err=>{
            this.exchangeRate= err.error.message;
        });
    }

    getPaymentRef() {
        switch (this.val) {
            case 1:
                this.reference = 'MONNIFY';
                break;
            case 2:
                this.reference = 'PAYSTACK';
                this.amounts = localStorage.advAmount * this.exchangeRate * 100;
                break;
            case 3:
                this.reference = 'INTERSWITCH';
                break;
            default:
        }
        this.amount = localStorage.advAmount;
        this.converted = this.amount * this.exchangeRate;
        const source = 'API';

        this.api
            .PaymentGeneratePayRef(this.reference, source)
            .subscribe((res: any) => {
                if(res.code == 200)
                this.reference = res.data;
                else
                this.toastr.error(
                    'Please try again',
                    'Something went wrong!',
                    {
                        positionClass: 'toast-bottom-center',
                        timeOut: 5000,
                    }
                );
                },
                (err) => {
                    this.errMsg=err.error.message;

                    if(this.errMsg === undefined)
                    this.errMsg = 'Network Error. Please check your connectivity.'
                    else{
                        this.errMsg=err.error.message;
                    }

                    this.toastr.error(
                        this.errMsg,
                        'Something went wrong!',
                        {
                            positionClass: 'toast-bottom-center',
                            timeOut: 5000,
                        }
                    );
                
                });
    }

    getUsersInfo() {
        this.api.UserInformation().subscribe((res: any) => {
            if(res.code == 200){
                this.userinfo = res.data;
                this.walletId = this.userinfo.id;
                this.getWallet();
            }
            else{
                this.check=true;
                this.errMsg = 'Network Error. Please check your connectivity.'
            }
        },
        (err) => {
            
            this.check=true;
            this.errMsg=err.error.message;

                if(this.errMsg === undefined)
                this.errMsg = 'Network Error. Please check your connectivity.'
                else{
                    this.errMsg=err.error.message;
                }
            });
    }

    //get VirtualAccount
    getWallet() {
        this.router.params.subscribe((params) => {
            this.wallet.getWallet(this.walletId).subscribe((res: any) => {
                this.vwallet = res.data;
                let type = this.vwallet.filter(
                    (virtual) =>
                        virtual.productType == 'ADVISORY' &&
                        virtual.provider == 'DW'
                );

                this.virtualAccount = type[0].VirtualAccount;
            });
        });
    }

    //still need rework
    paymentDone($event) {
        this.title = 'Payment successful';

        if (($event.message = 'Aproved')) {
            this.SpinnerService.show();
            this.api
                .confirmPayment(
                    this.converted,
                    'USD',
                    'PAYSTACK',
                    $event.reference,
                    true,
                    'success',
                    'ADVISORY'
                )
                .subscribe(
                    (res: any) => {
                        if (res.data) {
                            this.result = res;
                            this.toastr.success(
                                'Payment  confirmed !',
                                'Success!',
                                {
                                    positionClass: 'toast-bottom-center',
                                    timeOut: 5000,
                                }
                            );
                            this.fee = res.data.fee;
                            this.newamount = res.data.amount;
                            this.total = this.fee + res.data.amount;
                            this.currency = res.data.currencyCode;
                            this.MNfref = res.data.transactionReference;
                            this.SpinnerService.hide();

                            this.ngbmodalService.open(this.templateRef, {backdropClass: 'light-blue-backdrop'});
                            this.route.navigate(['/onboarding/menu']);
                        } else {
                            this.SpinnerService.hide();

                            this.toastr.warning(
                                'Payment could not be confirmed !',
                                'Something went wrong!',
                                {
                                    positionClass: 'toast-bottom-center',
                                    timeOut: 5000,
                                }
                            );
                            this.route.navigate(['/onboarding/menu']);
                        }
                    },
                    (err) => {
                        this.SpinnerService.hide();
                        this.errMsg=err.error.message;

                        if(this.errMsg === undefined)
                        this.errMsg = 'Network Error. Please check your connectivity.'
                        else{
                            this.errMsg=err.error.message;
                        }

                        this.toastr.error(
                            this.errMsg,
                            'Something went wrong!',
                            {
                                positionClass: 'toast-bottom-center',
                                timeOut: 5000,
                            }
                        );
                      
                    }
                );
        }
    }



    payWithMonnify() {
        MonnifySDK.initialize({
            amount: this.converted,
            currency: 'NGN',
            reference: this.reference,
            customerFullName: this.userinfo.username,
            customerEmail: this.userinfo.email,
            customerMobileNumber: this.userinfo.mobileNumber,
            apiKey: 'MK_TEST_JC82CV2PRP',
            contractCode: '7456839164',
            paymentDescription: 'Test Pay',
            isTestMode: true,
            metadata: {
                name: this.userinfo.username || '',
                age: 45,
            },
            onComplete: (response) => {
                
                //Monnify Reference
                this.MNfref = response.transactionReference;
            },
            onClose: (data) => {

                //Implement what should happen when the modal is closed here
                this.SpinnerService.show();
                //confirm payment call for Monnify
                this.api
                    .confirmPayment(
                        data.amountPaid,
                        'USD',
                        'MONNIFY',
                        data.transactionReference,
                        'true',
                        'success',
                        "ADVISORY"
                    )
                    .subscribe(
                        (res: any) => {
                            if (res.data) {
                                this.toastr.success(
                                    'Payment  confirmed !',
                                    'Success!',
                                    {
                                        positionClass: 'toast-bottom-center',
                                        timeOut: 5000,
                                    }
                                );
                                this.fee = res.data.fee;
                                this.newamount = res.data.amount;
                                this.total = this.fee + res.data.amount;
                                this.currency = res.data.currencyCode;
                                this.SpinnerService.hide();

                                this.ngbmodalService.open(this.templateRef, {backdropClass: 'light-blue-backdrop'});
                                this.route.navigate(['/onboarding/menu']);

                            } else {

                                this.toastr.warning(
                                    'Payment could not be confirmed !',
                                    'Something went wrong!',
                                    {
                                        positionClass: 'toast-bottom-center',
                                        timeOut: 5000,
                                    }
                                );
                            }
                        },
                        (err) => {
                            this.SpinnerService.hide();
                            
                            this.errMsg=err.error.message;

                            if(this.errMsg === undefined)
                            this.errMsg = 'Network Error. Please check your connectivity.'
                            else{
                                this.errMsg=err.error.message;
                            }


                            this.toastr.error(
                                err.error.message,
                                'Something went wrong!',
                                {
                                    positionClass: 'toast-bottom-center',
                                    timeOut: 6000,
                                }
                            );
                        }
                    );
            },
        });
    }

    submitHandler(event: any) {

        const ref = this.reference;
        if (!ref) {
            return;
        }
        const name = this.userinfo.username;
        const amounts = this.amount;
        const value = (this.converted * 100).toString();

        const onComplete = (res) => {
            console.log(res,'isw')
            if (res.resp === "00") {
                this.confirmISW(value, ref,amounts);
            }
        }

        const paymentRequest = {
            merchant_code: 'MX13651',
            pay_item_id: '9264129',
            txn_ref: ref,
            amount: value,
            currency: 566,
            site_redirect_url: window.location.href,
            onComplete: onComplete.bind(this),
            mode: 'TEST'
        };

        (window as any).webpayCheckout(paymentRequest);

    }

    confirmISW(value, reference,amounts) {
        this.SpinnerService.show();
        this.api
            .confirmPayment(
                value,
                'USD',
                'INTERSWITCH',
                reference,
                true,
                'success',
                'ADVISORY'
            )
            .subscribe(
                (res: any) => {
                    console.log(res,'mm')
                    if (res) {
                        this.result = res;
                        this.toastr.success(
                            'Payment  confirmed !',
                            'Success!',
                            {
                                positionClass: 'toast-bottom-center',
                                timeOut: 5000,
                            }
                        );
                        this.fee = res.data.fee;
                        this.newamount = res.data.amount;
                        this.total = this.fee + res.data.amount;
                        this.MNfref = res.data.transactionReference;
                        this.currency = res.data.currencyCode;
                        this.SpinnerService.hide();

                        this.ngbmodalService.open(this.templateRef, {backdropClass: 'light-blue-backdrop'});
                        this.route.navigate(['/onboarding/menu']);
                    } else {
                        this.SpinnerService.hide();

                        this.toastr.warning(
                            'Payment could not be confirmed !',
                            'Something went wrong!',
                            {
                                positionClass: 'toast-bottom-center',
                                timeOut: 5000,
                            }
                        );
                    }
                },
                (err) => {
                    this.SpinnerService.hide();

                    this.errMsg=err.error.message;

                    if(this.errMsg === undefined)
                    this.errMsg = 'Network Error. Please check your connectivity.'
                    else{
                        this.errMsg=err.error.message;
                    }

                    this.toastr.error(
                        this.errMsg,
                        'Something went wrong!',
                        {
                            positionClass: 'toast-bottom-center',
                            timeOut: 5000,
                        }
                    );
                })
    }
}
